import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the return page a "Returns" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/returns')({
  staticData: { crumb: 'common:nav.returns' },
  component: Outlet,
});
